import axios from 'axios';
import { ICo2Parameter } from '@/shared/model/co2-parameter.model';

const baseApiUrl = 'api/co2-parameters';

export default class Co2ParameterService {
  public find(id: number): Promise<ICo2Parameter> {
    return new Promise<ICo2Parameter>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }


  public create(entity: ICo2Parameter): Promise<ICo2Parameter> {
    return new Promise<ICo2Parameter>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: ICo2Parameter): Promise<ICo2Parameter> {
    return new Promise<ICo2Parameter>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public checkExist(): Promise<ICo2Parameter> {
    return new Promise<ICo2Parameter>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/currentYear`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
